import { IdNivelAcesso } from '@gestor-web/@core/types';
import * as Keycloak from 'keycloak-js';

export interface Usuario {
  cd_usuario: string;
  cd_usuario_keycloak: string;
  ds_email?: string;
  ds_email_verified?: number; // 0 ou 1
  nm_usuario?: string;
  nr_cpf?: string;
  nr_fone_celular?: string;
  nr_fone_comercial?: string;
  ds_cargo?: string;
  ib_situacao?: number;
  cd_papel_acesso?: string;
  im_foto?: string; // base64
  dt_alteracao?: string;
  dt_inclusao?: string;
  dt_ultimo_acesso?: string;
  qt_operadoras?: number;
}

export interface UsuarioOperadora extends Usuario {
  cd_registro_ans?: string;
  nm_operadora?: string;
  sg_operadora?: string;
  ib_dado_sensivel_pseudonimizado?: number;
  id_email_critica?: number;
  ds_comite_papel?: string;
  cd_comite_papel?: number;
}

/**
 * Perfil do usuário corrente. As três últimas colunas vêm de `apl_papel_acesso` e descrevem o
 * papel, não o usuário: ver `resolverAbrangencia` para como se combinam.
 */
export interface UsuarioPerfil extends Usuario {
  cd_registro_ans_preferencial?: string;
  operadoras_vinculadas?: VinculoUsuarioOperadora[];
  id_nivel_acesso?: IdNivelAcesso;
  ib_operadora?: number;
  ib_administrador?: number;
}

export interface VinculoUsuarioOperadoraBase {
  cd_registro_ans: string;
  nm_operadora: string;
  sg_operadora: string;
  modulos_liberados: PerfilModulos[];
  cd_comite_papel?: number;
  ds_comite_papel?: string;
}

export interface VinculoUsuarioOperadora extends VinculoUsuarioOperadoraBase {
  ib_dado_sensivel_pseudonimizado_usuario?: boolean; // 0 ou 1
  ib_dado_sensivel_pseudonimizado?: boolean; // 0 ou 1
  ib_email_critica?: boolean; // 0 ou 1
}

export interface VinculoUsuarioOperadoraAdmin extends VinculoUsuarioOperadoraBase {
  ib_dado_sensivel_pseudonimizado?: boolean; // 0 ou 1
}

export interface VinculoUsuarioOperadoraParams {
  cd_usuario_inclusao: string; // Id do usuário logado no sistema
  ib_dado_sensivel_pseudonimizado: boolean;
  id_email_critica: number;
  cd_comite_papel: string;
  cd_registro_ans: number;
}

export interface FullProfile {
  kc: KeycloakProfile;
  idss: UsuarioPerfil;
}

export interface PerfilModulos {
  cd_modulo: Modulos;
  dt_termino: string | null;
}

export type Modulos =
  | 'MONITOR'
  | 'REVISOR'
  | 'SIMULADOR'
  | 'PREMIUM'
  | 'QUALIFICA'
  | 'BMTISS'
  | 'REDIMENSIONA'
  | 'ESSENCIAL';

export type KeycloakProfile = Keycloak.KeycloakProfile;

export class UsuarioConvite {
  nm_usuario: string;
  ds_email: string;
  cd_papel_acesso?: string;
  ds_url_applicacao: string;
}
